module.exports = __webpack_public_path__ + "img/shares.b20798b6.png";